import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

interface FeaturesProps {
  brandFormPayload: UseBrandFormPayload,
}

const Features = (props: FeaturesProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      options,
    },
  } = brandFormPayload

  const {
    cross_agency_collaboration,
    template_designer,
  } = options

  return (
    <DashboardModule title="Features">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => (
            toggleNestedValue(brandFormPayload, 'options.cross_agency_collaboration', { shouldSetState: true })
          )}
          toggleValue={!!cross_agency_collaboration}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Cross Agency Collaboration</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies can assign campaigns to agencies linked by brand
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => toggleNestedValue(brandFormPayload, 'options.template_designer', { shouldSetState: true })}
          toggleValue={!!template_designer}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Brand Template Management</ToggleListItem.Title>

          <ToggleListItem.Description>
            Brand can access and control template access with Brand Admin
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

export default Features
